export const PROMPT_SUB_TEMPLATE_ID = '-1';

export const TEMPLATE_TYPE = {
  generationTool: 'generation_tool',
  subTemplate: 'sub_template',
  customMultiPrompt: 'custom_multi_prompt',
} as const;
export type TemplateType = (typeof TEMPLATE_TYPE)[keyof typeof TEMPLATE_TYPE];
